<div class="mt-5 mb-2 flex">
  <div class="font-bold text-xl">{{'handover.damages' |translate}}</div>
</div>
<div *ngIf="!model?.damages || model?.damages?.length === 0 else damagesTemp">
  <div class="tk-border-gray-2 px-5 py-4 rounded-xl">
    {{'handover.no-damages' | translate}}
  </div>
</div>
<ng-template #damagesTemp>
  <handoverm-handover-section 
    *ngFor="let item of model?.damages"
    [desc]="item?.desc"
    [images]="item?.imageUrls"
    [model]="model"
  ></handoverm-handover-section>
</ng-template>
